import React from 'react';

const SuccessModalComponent = ({message}) => (
    <div className="modal-root">
        <p>{message}</p>
    </div>
);

export default SuccessModalComponent;